import { Heading } from "@chakra-ui/react";
import React, { ReactNode } from "react";

const PageTitle = ({ children }: { children: ReactNode }) => {
    return (
        <Heading as='h1' size='2xl' textAlign='center' mt={{ base: 4, md: 12 }} mb={{ base: 8, md: 12 }}>{children}</Heading>
    );
};

export default PageTitle;